import { QuestionCircleOutlined } from '@ant-design/icons'
import { Check, Edit, X } from 'react-feather'
import { createSelector } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Form, Typography, Popover, Card, InputNumber } from 'antd'
import WeaverService from 'Services/WeaverService'
import { setNodeLimit } from 'Actions/graph'
import { GraphConfig } from 'Model'
import { useEffect, useState } from 'react'

const { Paragraph, Text } = Typography

const graphConfigHelpText = (
  <div style={{ width: 500, lineHeight: '1.6rem', whiteSpace: 'pre-wrap' }}>
    <Paragraph>
      All <Text mark>Graph</Text> related configuration.
    </Paragraph>
    <Text type="secondary">
      This determines the structure and properties of the graph. It allows the user to customise how nodes and edges are displayed.
    </Text>
  </div>
)

const info = (
  <Popover
    content={graphConfigHelpText}
    title='Graph Config'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

const nodeLimitSelector = createSelector((state) => state.graph.nodeLimit, (val) => val)

export default () => {
  const nodeLimit = useSelector(nodeLimitSelector)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [configNode, setConfigNode] = useState()
  const [isEditing, setIsEditing] = useState(false)

  useEffect(() => {
    (async () => {
      const node = await GraphConfig.load()
      setConfigNode(node)
      setLoading(false)
    })()
    undefined
  }, [])

  const commitChanges = ({ nodeLimit }) => {
    dispatch(setNodeLimit(nodeLimit))
    configNode.setNodeLimit(nodeLimit)
  }

  const checkButton = (
    <Form.Item>
      <Button
        type="text"
        htmlType="submit"
      >
        <Check />
      </Button>
    </Form.Item>
  )

  const cancelButton = (
    <Button type="text">
      <X />
    </Button>
  )

  const editButton = (
    <Button
      type="text"
      disabled={!WeaverService.userCanEdit()}
      onClick={() => setIsEditing(true)}
    >
      <Edit />
    </Button>
  )

  const actions = isEditing ? [checkButton, cancelButton] : [editButton]

  return (
    <Form
      onFinish={(vals) => {
        commitChanges(vals)
        setIsEditing(false)
      }}
      initialValues={{
        nodeLimit: nodeLimit,
      }}
    >
      <Card
        title="Graph Config"
        loading={loading}
        extra={info}
        size="small"
        actions={actions}
      >
        <Form.Item
          label="Node Limit"
          name="nodeLimit"
        >
          <InputNumber disabled={!isEditing} />
        </Form.Item>
      </Card>
    </Form>
  )
}
